// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerLinkListStyles } from "@stoneage/Overrides/Widgets/Header/HeaderLinkList";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";
import { color } from "@stoneage/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
    `,
};

headerLinkListStyles.link = {
    color: "common.white",
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        css: css`
            display: flex;
            align-items: center;
            gap: 8px;
        `,
    },
    css: css`
        padding: 8px 12px;
        ${IconWrapper} {
            transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;
        }

        &:hover,
        &[data-state="open"] {
            background-color: ${color("primary")};
            ${TypographyStyle},
            ${IconWrapper},
            ${IconWrapper} svg {
                color: ${color("common.white")};
            }
            ${IconWrapper}.arrow-icon {
                rotate: 180deg;
            }
        }
    `,
};
headerLinkListStyles.menuItemLink = {
    color: "common.white",
    typographyProps: {
        ...fontConfig.smallSingleLine,
        weight: fontConfig.weight.medium,
    },
    css: css`
        padding: 12px;
    `,
};

headerLinkListStyles.iconLink = {
    color: "common.ui6",
    size: 12,
};

headerLinkListStyles.arrowIcon = {
    color: "common.ui6",
    size: 12,
};

headerLinkListStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
        `,
    },
};
